import { Badge } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { getAuditActionPresentation } from "./auditLogBadges";

type Props = {
  action: string;
};

export function AuditActionBadge({ action }: Props) {
  const { t } = useTranslation();
  const { tone, labelKey } = getAuditActionPresentation(action);
  return (
    <Badge tone={tone}>
      {t(labelKey, { defaultValue: action })}
    </Badge>
  );
}
